// ═══════════════════════════════════════════════════════════════════════════════
// Shared wizard step indicator + progress bar (pickup / medication task groups)
// ═══════════════════════════════════════════════════════════════════════════════

type TaskGroupWizardProgressProps = {
  currentStep: number;
  totalSteps: number;
  t: (key: string, params?: Record<string, string | number>) => string;
};

export const TaskGroupWizardProgress = ({
  currentStep,
  totalSteps,
  t,
}: TaskGroupWizardProgressProps) => (
  <div
    className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm dark:border-gray-700 dark:bg-gray-900"
    role="status"
    aria-live="polite"
  >
    <p className="text-xs font-medium text-gray-500 dark:text-gray-400">
      {t('task.group.wizard.stepOf', { current: currentStep, total: totalSteps })}
    </p>
    <div className="mt-3 h-2 w-full overflow-hidden rounded-full bg-gray-200 dark:bg-gray-700">
      <div
        className="h-2 rounded-full bg-primary-600 transition-all dark:bg-primary-500"
        style={{ width: `${(currentStep / totalSteps) * 100}%` }}
      />
    </div>
  </div>
);
